import type { FC, ReactNode } from "react";
import { Flex, Spacing, Text } from "@huub-web/ui";

import {
  contentColumnStyle,
  descriptionStyle,
  imagePanelStyle,
  imageStyle,
  titleStyle,
  wrapperStyle,
} from "./AllianzBanner.css";

type AllianzBannerProps = {
  children?: ReactNode;
  /**
   * Banner title displayed in the right panel
   */
  title: string;
  /**
   * Banner description displayed below the title
   */
  description: string;
  /**
   * URL of the image to display in the left panel
   */
  imageSrc: string;
};

/**
 * Reusable grid banner for Allianz theme slot overrides.
 * Below 400px: single column (image hidden).
 * Above 400px: two columns -- image left, content right.
 */
export const AllianzBanner: FC<AllianzBannerProps> = ({
  children,
  title,
  description,
  imageSrc,
}) => {
  return (
    <>
      <Spacing height="m" />
      <div className={wrapperStyle}>
        <div className={imagePanelStyle}>
          <img className={imageStyle} src={imageSrc} alt="" loading="eager" />
        </div>
        <Flex direction="column" gap="m" className={contentColumnStyle}>
          <Text variant="displayM" bold className={titleStyle}>
            {title}
          </Text>
          <Text
            variant="bodyM"
            color="currentColor75"
            className={descriptionStyle}
          >
            {description}
          </Text>
          {children}
        </Flex>
      </div>
    </>
  );
};
